import { useCallback } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { CATEGORIES } from '@r1-frontend/shared/constants/analytics';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import Card from './Card';
import { data } from './data';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';
import * as ST from './styled';

interface IProps{
    cityIn: string,
    isVillage?: boolean,
}

const sDesktop = `(max-width: ${breakePoints.sDesktop})`;
const mobile = `(max-width: ${breakePoints.mobile})`;

export const HowItWork = ({ cityIn, isVillage = false }: IProps): JSX.Element => {
    const isLaptop = useMatchMedia(sDesktop);
    const isMobile = useMatchMedia(mobile);

    const onClick = useCallback(() => {
        dataLayerPush({
            event: 'UAevent',
            category: CATEGORIES.vas,
            action: 'click btn add router',
            label: '/internet/equipment',
        });
    }, []);

    return (
        <ST.HowItWork>
            <ST.Title>Как работает наш (то есть ваш) интернет{isVillage ? ' в загородном доме' : ''}</ST.Title>
            <ST.SubTitle>{`Оставьте заявку, чтобы подключить интернет в ${cityIn}.`}</ST.SubTitle>
            {isLaptop
                ? <SlideCarousel
                    withoutArrows={true}
                    wrapAround={true}
                    framePadding={'0 0 0 0'}
                    slideWidth={isMobile ? 286 : 316}
                    cellSpacing={20}
                    initialSlideHeight={400}
                >
                    {data.map((item) => {
                        return (
                            <Card
                                key={item.id}
                                {...item}
                                isVertical={true}
                                onClick={onClick}
                            />
                        );
                    })}
                </SlideCarousel>
                : <ST.ListWrap>
                    <ST.SRow>
                        {data.map((item) => {
                            if (item.id > 2) {
                                return null;
                            }

                            return (
                                <ST.SCol key={item.id}>
                                    <Card
                                        {...item}
                                        onClick={onClick}
                                    />
                                </ST.SCol>
                            );
                        })}
                    </ST.SRow>
                    <ST.SRow>
                        {data.map((item) => {
                            if (item.id <= 2) {
                                return null;
                            }

                            return (
                                <ST.SCol key={item.id}>
                                    <Card
                                        {...item}
                                        isVertical={true}
                                    />
                                </ST.SCol>
                            );
                        })}
                    </ST.SRow>
                </ST.ListWrap>
            }
        </ST.HowItWork>
    );
};
